<template>
  <div class="div"></div>
</template>

<script>
export default {
  methods: {},
};
</script>

<style></style>
